/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Color } from '../models';
/**
 * ColorsApi - axios parameter creator
 * @export
 */
export const ColorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorDestroy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainColorDestroy', 'id', id)
            const localVarPath = `/api/main/color/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {string} [color] 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorPartialUpdate: async (id: number, name?: string, color?: string, ecommerceName?: string, description?: string, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainColorPartialUpdate', 'id', id)
            const localVarPath = `/api/main/color/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (color !== undefined) { 
                localVarFormParams.append('color', color as any);
            }
    
            if (ecommerceName !== undefined) { 
                localVarFormParams.append('ecommerce_name', ecommerceName as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainColorRetrieve', 'id', id)
            const localVarPath = `/api/main/color/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {string} [color] 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorUpdate: async (id: number, name?: string, color?: string, ecommerceName?: string, description?: string, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainColorUpdate', 'id', id)
            const localVarPath = `/api/main/color/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (color !== undefined) { 
                localVarFormParams.append('color', color as any);
            }
    
            if (ecommerceName !== undefined) { 
                localVarFormParams.append('ecommerce_name', ecommerceName as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} color 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorsCreate: async (name: string, color: string, ecommerceName?: string, description?: string, image?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('mainColorsCreate', 'name', name)
            // verify required parameter 'color' is not null or undefined
            assertParamExists('mainColorsCreate', 'color', color)
            const localVarPath = `/api/main/colors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (color !== undefined) { 
                localVarFormParams.append('color', color as any);
            }
    
            if (ecommerceName !== undefined) { 
                localVarFormParams.append('ecommerce_name', ecommerceName as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/colors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ColorsApi - functional programming interface
 * @export
 */
export const ColorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ColorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorDestroy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {string} [color] 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorPartialUpdate(id: number, name?: string, color?: string, ecommerceName?: string, description?: string, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Color>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorPartialUpdate(id, name, color, ecommerceName, description, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Color>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [name] 
         * @param {string} [color] 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorUpdate(id: number, name?: string, color?: string, ecommerceName?: string, description?: string, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Color>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorUpdate(id, name, color, ecommerceName, description, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} color 
         * @param {string} [ecommerceName] 
         * @param {string} [description] 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorsCreate(name: string, color: string, ecommerceName?: string, description?: string, image?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Color>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorsCreate(name, color, ecommerceName, description, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainColorsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Color>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainColorsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ColorsApi.mainColorsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ColorsApi - factory interface
 * @export
 */
export const ColorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ColorsApiFp(configuration)
    return {
        /**
         * 
         * @param {ColorsApiMainColorDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorDestroy(requestParameters: ColorsApiMainColorDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mainColorDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ColorsApiMainColorPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorPartialUpdate(requestParameters: ColorsApiMainColorPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Color> {
            return localVarFp.mainColorPartialUpdate(requestParameters.id, requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ColorsApiMainColorRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorRetrieve(requestParameters: ColorsApiMainColorRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Color> {
            return localVarFp.mainColorRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ColorsApiMainColorUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorUpdate(requestParameters: ColorsApiMainColorUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Color> {
            return localVarFp.mainColorUpdate(requestParameters.id, requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ColorsApiMainColorsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorsCreate(requestParameters: ColorsApiMainColorsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Color> {
            return localVarFp.mainColorsCreate(requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainColorsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Color>> {
            return localVarFp.mainColorsList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for mainColorDestroy operation in ColorsApi.
 * @export
 * @interface ColorsApiMainColorDestroyRequest
 */
export interface ColorsApiMainColorDestroyRequest {
    /**
     * 
     * @type {number}
     * @memberof ColorsApiMainColorDestroy
     */
    readonly id: number
}

/**
 * Request parameters for mainColorPartialUpdate operation in ColorsApi.
 * @export
 * @interface ColorsApiMainColorPartialUpdateRequest
 */
export interface ColorsApiMainColorPartialUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly color?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly ecommerceName?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly description?: string

    /**
     * 
     * @type {File}
     * @memberof ColorsApiMainColorPartialUpdate
     */
    readonly image?: File
}

/**
 * Request parameters for mainColorRetrieve operation in ColorsApi.
 * @export
 * @interface ColorsApiMainColorRetrieveRequest
 */
export interface ColorsApiMainColorRetrieveRequest {
    /**
     * 
     * @type {number}
     * @memberof ColorsApiMainColorRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for mainColorUpdate operation in ColorsApi.
 * @export
 * @interface ColorsApiMainColorUpdateRequest
 */
export interface ColorsApiMainColorUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly name?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly color?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly ecommerceName?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly description?: string

    /**
     * 
     * @type {File}
     * @memberof ColorsApiMainColorUpdate
     */
    readonly image?: File
}

/**
 * Request parameters for mainColorsCreate operation in ColorsApi.
 * @export
 * @interface ColorsApiMainColorsCreateRequest
 */
export interface ColorsApiMainColorsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorsCreate
     */
    readonly name: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorsCreate
     */
    readonly color: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorsCreate
     */
    readonly ecommerceName?: string

    /**
     * 
     * @type {string}
     * @memberof ColorsApiMainColorsCreate
     */
    readonly description?: string

    /**
     * 
     * @type {File}
     * @memberof ColorsApiMainColorsCreate
     */
    readonly image?: File
}

/**
 * ColorsApi - object-oriented interface
 * @export
 * @class ColorsApi
 * @extends {BaseAPI}
 */
export class ColorsApi extends BaseAPI {
    /**
     * 
     * @param {ColorsApiMainColorDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorDestroy(requestParameters: ColorsApiMainColorDestroyRequest, options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ColorsApiMainColorPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorPartialUpdate(requestParameters: ColorsApiMainColorPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorPartialUpdate(requestParameters.id, requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ColorsApiMainColorRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorRetrieve(requestParameters: ColorsApiMainColorRetrieveRequest, options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ColorsApiMainColorUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorUpdate(requestParameters: ColorsApiMainColorUpdateRequest, options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorUpdate(requestParameters.id, requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ColorsApiMainColorsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorsCreate(requestParameters: ColorsApiMainColorsCreateRequest, options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorsCreate(requestParameters.name, requestParameters.color, requestParameters.ecommerceName, requestParameters.description, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ColorsApi
     */
    public mainColorsList(options?: RawAxiosRequestConfig) {
        return ColorsApiFp(this.configuration).mainColorsList(options).then((request) => request(this.axios, this.basePath));
    }
}

